//#region src/getUsedExports.ts
function getUsedExports(webpackRequire, sharedName) {
    var usedExports = webpackRequire.federation.usedExports;
    if (!usedExports) return;
    return usedExports[sharedName];
}
//#endregion
exports.getUsedExports = getUsedExports; //# sourceMappingURL=getUsedExports.cjs.map
